import { render, staticRenderFns } from "./AlbumShare.vue?vue&type=template&id=39d72dcc&scoped=true"
import script from "./AlbumShare.vue?vue&type=script&lang=js"
export * from "./AlbumShare.vue?vue&type=script&lang=js"
import style0 from "./AlbumShare.vue?vue&type=style&index=0&id=39d72dcc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d72dcc",
  null
  
)

export default component.exports